export * from "./getCompOnlyMessage";
